module.exports = __webpack_public_path__ + "static/img/MOGO-P5-P9@2x.b21189e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/MOGO-P5-P9@2x.jpg
// module id = 98
// module chunks = 0